import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import {
	LegislativeBodiesFeatureConfig,
	type LegislativeBodiesFeatureConfigQuery,
	type LegislativeBodiesFeatureConfigQueryVariables,
} from './legislativeBodiesConfig.graphql';

export async function getLegislativeBodiesConfig({ gql: { fetch } }: UtilityContext): Promise<boolean> {
	const { data } = await fetch<LegislativeBodiesFeatureConfigQuery, LegislativeBodiesFeatureConfigQueryVariables>({
		query: LegislativeBodiesFeatureConfig,
		rejectOnError: true,
	});

	return data.featureConfigs.decisionMakersLegislativeBodies || false;
}
